import { IPeriodLevel } from "backend/model/model";
import * as conf from "qpr-base/configuration";
import { Projects, ProjectValues } from "../ProjectForm/index.dto";
import { getProjectPeriods } from "../ValuesForm";
import { mapSubItemToMilestone } from "./dataMapperSubItems";
import {
  MeaElement,
  Milestone_JS_ATTR,
  Project_JS_ATTR,
  WorkflowData,
} from "./dataMapperTypes";

const getStringValue = (val: any) => {
  if (val === undefined || val === null) {
    return "";
  }
  return val.toString();
};

const getMeasureValues = (
  valueObj: any,
  projectPeriods: string[],
  jsAttr: string,
  startDate: string,
  endDate: string,
  weightValue?: string,
  budgetValue?: string
): { series: string; period: string; value: string }[] => {
  const resultValues = [
    {
      series: "JS_ATTR",
      period: "firstforseries",
      value: jsAttr,
    },
    ...[
      ...projectPeriods.map((periodName) => ({
        series: "START_DATE",
        period: periodName,
        value: startDate,
      })),
      ...projectPeriods.map((periodName) => ({
        series: "END_DATE",
        period: periodName,
        value: endDate,
      })),
      ...(budgetValue ? projectPeriods : []).map((periodName) => ({
        series: "BUDGET",
        period: periodName,
        value: getStringValue(budgetValue),
      })),
      ...(weightValue ? projectPeriods : []).map((periodName) => ({
        series: "WEIGHT",
        period: periodName,
        value: getStringValue(weightValue),
      })),
    ],
  ];
  if (!valueObj) return resultValues;

  for (const [key, value] of Object.entries(valueObj)) {
    const seriesAndPeriod = key.split("###");
    resultValues.push({
      series: seriesAndPeriod[0],
      period: seriesAndPeriod[1],
      value: getStringValue(value),
    });
  }

  console.log("project values after mapping", resultValues);

  return resultValues;
};

export const mapProjectToWorkflow = (
  data: ProjectValues,
  meaId: string,
  periodLevels: IPeriodLevel[],
  valueSettings: any[]
): WorkflowData => {
  const lang: string[] = conf.getLanguages();
  const projectStartDate = data.scheduleAndBudget["Project Start Date"]
    ? data.scheduleAndBudget["Project Start Date"]
    : "";
  const projectEndDate = data.scheduleAndBudget["Project End Date"]
    ? data.scheduleAndBudget["Project End Date"]
    : "";

  const JS_ATTR: Project_JS_ATTR = {
    "Localized-Text-Attributes": {
      [lang[0]]: {
        ...data.basicInformation[lang[0]],
      },
      [lang[1]]: {
        ...data.basicInformation[lang[1]],
      },
    },
    "Project Budget": data.scheduleAndBudget.budget?.toString() || "",
    "Project Start Date": projectStartDate,
    "Project End Date": projectEndDate,
  };
  const projectPeriods: string[] = getProjectPeriods(
    data.periodlevelid,
    periodLevels,
    projectStartDate,
    projectEndDate
  );

  const JS_ATTR_STRINGIFIED = JSON.stringify(JS_ATTR);
  const operationType = meaId ? "modify" : "create";

  const result = {
    elementType: "Initiative",
    type: operationType,
    meaId: meaId || data.parentelementid,
    parameters: {
      elements: [
        {
          elementType: "Initiative",
          ...(meaId
            ? {
                meaId: meaId,
                operation: "modify",
              }
            : { meaId: data.parentelementid }),
          attributes: [
            ["name", data.basicInformation[lang[0]]["Name"] || "-"],
            [
              "description",
              data.basicInformation[lang[0]]["Description"] || "",
            ],
            [
              "valuesettingid",
              valueSettings.find((vs) => vs.name === "Initiative")?.id || "",
            ],
            ["periodlevelid", data.periodlevelid || ""],
            ["measureunitid", data.measureunitid || ""],
            ["parentelementid", data.parentelementid || ""],
          ].filter((e: any) => e[1] !== "error"),
          values: getMeasureValues(
            data.values,
            projectPeriods,
            JS_ATTR_STRINGIFIED,
            projectStartDate,
            projectEndDate,
            "",
            data.scheduleAndBudget.budget?.toString()
          ),

          /*
          values: [
            {
              series: "JS_ATTR",
              period: "firstforseries",
              value: JS_ATTR_STRINGIFIED,
            }, 
            ...[
              ...projectPeriods.map((periodName) => ({
                series: "START_DATE",
                period: periodName,
                value: data.scheduleAndBudget["Project Start Date"],
              })),
              ...projectPeriods.map((periodName) => ({
                series: "END_DATE",
                period: periodName,
                value: data.scheduleAndBudget["Project End Date"],
              })),
            ]
              .map((date) => ({
                ...date,
                value:
                  date.value && JSON.stringify(date.value) !== "null"
                    ? date.value
                    : "",
              }))
              .filter((date) => date.value),
            ...data.projectValues
              .map((value, ind) => {
                if (projectPeriods.length <= ind) {
                  return [];
                }
                return [
                  {
                    series: "COMPLETION_PERCENTAGE",
                    period: projectPeriods[ind],
                    value: getStringValue(value?.ACT),
                  },
                  ...[
                    {
                      series: "ACTUAL_START_DATE",
                      period: projectPeriods[ind],

                      value:
                        value && "Project Start Date" in value
                          ? value["Project Start Date"]
                          : undefined,
                    },
                    {
                      series: "ACTUAL_END_DATE",
                      period: projectPeriods[ind],

                      value:
                        value && "Project End Date" in value
                          ? value["Project End Date"]
                          : undefined,
                    },
                  ].map((date) => ({
                    ...date,
                    value:
                      date.value && JSON.stringify(date.value) !== "null"
                        ? date.value
                        : "",
                  })),
                  {
                    series: "PLANNED_COMPLETION",
                    period: projectPeriods[ind],

                    value: getStringValue(value?.TAR),
                  },
                  {
                    series: "BUDGET",
                    period: projectPeriods[ind],
                    value: getStringValue(value?.projectBudget),
                  },
                  {
                    series: "EXPENDITURE",
                    period: projectPeriods[ind],
                    value: getStringValue(value?.projectExpenditure),
                  },
                ];
              })
              .reduce((cur, prev) => [...cur, ...prev], []),
          ].map((cur) => ({
            ...cur,
            value:
              cur.value === undefined || cur.value === null
                ? ""
                : cur.value.toString(),
          })),
          */
          subElements: [
            ...[
              ...data.Milestones.map((milestone) => {
                const sub_JS_ATTR: Milestone_JS_ATTR = {
                  ID: "" as string,
                  "Localized-Text-Attributes": {
                    [lang[0]]: milestone["basicInformation"]?.[lang[0]] || {},
                    [lang[1]]: milestone["basicInformation"]?.[lang[1]] || {},
                  },
                };
                const MILESTONE_JS_ATTR = JSON.stringify(sub_JS_ATTR);

                const milestoneStartDate = milestone[
                  "Milestone planned start date"
                ]
                  ? milestone["Milestone planned start date"]
                  : "";
                const milestoneEndDate = milestone["Milestone planned end date"]
                  ? milestone["Milestone planned end date"]
                  : "";
                const milestonePeriods: string[] = getProjectPeriods(
                  data.periodlevelid,
                  periodLevels,
                  milestoneStartDate,
                  milestoneEndDate
                );

                const milestoneWeight = getStringValue(
                  milestone["Milestone weight"]
                );

                return {
                  elementType: "Milestone",
                  operation: milestone.meaId ? milestone.status : "create",
                  ...(milestone.meaId
                    ? {
                        meaId: milestone.meaId,
                      }
                    : { meaId: "" }),

                  attributes: [
                    [
                      "name",
                      milestone.basicInformation?.[lang[0]]?.["Project Name"] ||
                        "-",
                    ],
                    [
                      "description",
                      milestone.basicInformation?.[lang[0]]?.[
                        "Milestone Description"
                      ] || "-",
                    ],
                    [
                      "valuesettingid",
                      valueSettings.find((vs) => vs.name === "Milestone")?.id ||
                        "",
                    ],
                    ["periodlevelid", data.periodlevelid || ""],
                  ].filter((e: any) => e[1] !== "error"),
                  values: getMeasureValues(
                    milestone.values,
                    milestonePeriods,
                    MILESTONE_JS_ATTR,
                    milestoneStartDate,
                    milestoneEndDate,
                    milestoneWeight
                  ),
                  /*
                  values: [
                    {
                      series: "JS_ATTR",
                      period: "firstforseries",
                      value: stringified_sub_JS_ATTR,
                    },
                    ...milestonePeriods.map((periodName) => ({
                      series: "START_DATE",
                      period: periodName,
                      value: milestoneStartDate,
                    })),
                    ...milestonePeriods.map((periodName) => ({
                      series: "END_DATE",
                      period: periodName,
                      value: milestoneEndDate,
                    })),
                    ...milestonePeriods.map((periodName) => ({
                      series: "WEIGHT",
                      period: periodName,
                      value: getStringValue(milestone["Milestone weight"]),
                    })),
                    ...milestone.milestoneValues
                      .map((value, ind) => {
                        if (!value || ind >= milestonePeriods.length) {
                          return [];
                        }
                        return Object.entries(value)
                          .map(([key, val]) => {
                            switch (key) {
                              case "milestoneProgress": {
                                return {
                                  series: "COMPLETION_PERCENTAGE",
                                  period: milestonePeriods[ind],
                                  value: val?.toString() || "",
                                };
                              }
                              case "Project Start Date": {
                                return {
                                  series: "ACTUAL_START_DATE",
                                  period: milestonePeriods[ind],
                                  value:
                                    val && JSON.stringify(val) !== "null"
                                      ? val
                                      : null,
                                };
                              }
                              case "Project End Date": {
                                return {
                                  series: "ACTUAL_END_DATE",
                                  period: milestonePeriods[ind],

                                  value:
                                    val && JSON.stringify(val) !== "null"
                                      ? val
                                      : null,
                                };
                              }
                              case "milestonePlannedProgress": {
                                return {
                                  series: "PLANNED_COMPLETION",
                                  period: milestonePeriods[ind],

                                  value: getStringValue(val),
                                };
                              }
                              default: {
                                return {
                                  series: "",
                                  period: "",
                                  value: "",
                                };
                              }
                            }
                          })
                          .filter(
                            (cur) => cur.period !== "" && cur.series !== ""
                          );
                      })
                      .reduce((cur, prev) => [...cur, ...prev], []),
                  ].map((cur) => ({
                    ...cur,
                    value:
                      cur.value === undefined || cur.value === null
                        ? ""
                        : cur.value.toString(),
                  })),
                  */

                  subElements: [],
                };
              }),
            ],
          ],
        },
      ],
    },
  };

  const removeEmptyValues = (elements: any[]) => {
    for (let i = 0; i < elements.length; i += 1) {
      if (elements[i].values)
        elements[i].values = elements[i].values.filter(
          (valueObj: any) => valueObj.value !== ""
        );
      if (elements[i].subElements) removeEmptyValues(elements[i].subElements);
    }
  };

  if (operationType === "create") {
    removeEmptyValues(result.parameters.elements);
  }
  return result;
};

export const mapWorkflowToProjectValues = (
  data: WorkflowData,
  periodLevels: IPeriodLevel[]
): ProjectValues => {
  const unparsedData = data.parameters.elements[0].values.find(
    (cur) => cur.series === "JS_ATTR"
  )?.value;
  const workflow = unparsedData
    ? (JSON.parse(unparsedData) as Project_JS_ATTR)
    : ({} as Project_JS_ATTR);
  const values = data.parameters.elements[0].values || [];
  const end_date = values.find((m) => m.series === "END_DATE")?.value;
  const start_date = values.find((m) => m.series === "START_DATE")?.value;

  const periodlevelid = data.parameters.elements[0].attributes.find(
    (e: any) => e[0] === "periodlevelid"
  );

  const periods: string[] = getProjectPeriods(
    periodlevelid?.[1] || "",
    periodLevels,
    start_date,
    end_date
  );

  const mappedValues: Projects[] = periods.map((period) => {
    const valuesWithPeriod = values.filter((v) => v.period === period);
    const projectStartDateValue = valuesWithPeriod.find(
      (v) => v.series === "ACTUAL_START_DATE"
    )?.value;
    const projectEndDateValue = valuesWithPeriod.find(
      (v) => v.series === "ACTUAL_END_DATE"
    )?.value;
    return {
      period: period,
      ACT:
        valuesWithPeriod.find((v) => v.series === "COMPLETION_PERCENTAGE")
          ?.value || "",
      TAR:
        valuesWithPeriod.find((v) => v.series === "PLANNED_COMPLETION")
          ?.value || "",
      "Project Start Date": projectStartDateValue || "",
      // ? new Date(`${projectStartDateValue}T00:00:00-05:00`)
      //: undefined,
      "Project End Date": projectEndDateValue || "",
      // ? new Date(`${projectEndDateValue}T00:00:00-05:00`)
      // : undefined,
      projectBudget:
        valuesWithPeriod.find((v) => v.series === "BUDGET")?.value || "",
      projectExpenditure:
        valuesWithPeriod.find((v) => v.series === "EXPENDITURE")?.value || "",
      actualProgress: "",
      plannedProgress: "",
      projectEndDate: "",
      projectStartDate: "",
    };
  });

  const mapMeaProjectValues = (): any => {
    const projectValueSeries = [
      "ACTUAL_START_DATE",
      "ACTUAL_END_DATE",
      "COMPLETION_PERCENTAGE",
      "PLANNED_COMPLETION",
      "EXPENDITURE",
    ];
    const valueObj: any = {};

    for (let i = 0; i < values.length; i += 1) {
      if (projectValueSeries.includes(values[i].series)) {
        valueObj[`${values[i].series}###${values[i].period}`] = values[i].value;
      }
    }
    return valueObj;
  };

  const unit = data.parameters.elements[0].attributes.find(
    (e: any) => e[0] === "measureunitid"
  );
  const valuesettingid = data.parameters.elements[0].attributes.find(
    (e: any) => e[0] === "valuesettingid"
  );

  const parentelementid = data.parameters.elements[0].attributes.find(
    (e: any) => e[0] === "parentelementid"
  );

  const milestones = data.parameters.elements[0].subElements?.filter(
    (obj) => !("referenceFrom" in obj) || []
  );

  const lang: string[] = conf.getLanguages();

  let topelementid;
  let parentElement: any = undefined;
  let prioritySymbol = "";
  let perspectiveSymbol = "";
  if (parentelementid?.length) {
    parentElement = data.parentHierarchy?.find(
      (element: any) => element.id === parentelementid[1]
    );
    if (parentElement) topelementid = parentElement.topelementid;
  }

  if (parentElement?.typename === "Perspective")
    perspectiveSymbol = parentElement.symbol;
  if (parentElement?.typename === "Strategic Objective") {
    prioritySymbol = parentElement.symbol;
    perspectiveSymbol =
      data.parentHierarchy?.find(
        (element: any) => element.id === parentElement.parentelementid
      )?.symbol || "";
  }

  return {
    meaId: data.parameters.elements[0].meaId || "",
    basicInformation: {
      [lang[0]]: {
        Description:
          workflow["Localized-Text-Attributes"]?.[lang[0]]?.Description || "",
        Name: workflow["Localized-Text-Attributes"]?.[lang[0]]?.Name || "",
      },
      [lang[1]]: {
        Description:
          workflow["Localized-Text-Attributes"]?.[lang[1]]?.Description || "",
        Name: workflow["Localized-Text-Attributes"]?.[lang[1]]?.Name || "",
      },
    },
    measureunitid: unit?.[1] || "",
    parentelementid: parentelementid?.[1] || "",
    valuesettingid: valuesettingid?.[1] || "",
    periodlevelid: periodlevelid?.[1] || "",
    location: {
      topelementid: topelementid || "",
      themesymbol: perspectiveSymbol,
      prioritysymbol: prioritySymbol,
    },
    scheduleAndBudget: {
      "Project End Date": end_date || "",
      // ? new Date(`${end_date}T00:00:00-05:00`)
      // : undefined,
      "Project Start Date": start_date || "",
      // ? new Date(`${start_date}T00:00:00-05:00`)
      //  : undefined,
      budget: workflow["Project Budget"] || "",
    },
    projectValues: [], //mappedValues,
    values: mapMeaProjectValues(),
    Milestones: mapSubItemToMilestone(
      data.parameters.elements[0].meaId || "",
      milestones as MeaElement[],
      periods
    ),
  };
};
